import {
  Classifications,
  GlobalSearchTable,
  Tutorials,
  Queries,
  AssignmentWorkspace,
  ReleaseNotes,
  SmeEvaluation,
  SmeClassificationView,
  StatementReauthorization,
  SupportCases,
  ImporterManagementPage,
} from './loadableComponents';
import { getEnv } from '@xbcb/ui-utils';
import { UiStage } from '@xbcb/ui-types';
import { isReleaseNoteViewEnabled } from 'featureFlags';

const { stage } = getEnv();

export type IndependentRoute = {
  Page: React.FC;
  path: string;
};

// IndependentRoutes are the ones rendered by AuthenticatedRoutes, but are not specific to a record type. Thus, it should be rendered here rather than as part of the AppRecord framework.
export const independentRoutes: IndependentRoute[] = [
  {
    Page: GlobalSearchTable,
    path: '/search',
  },
  {
    Page: Tutorials,
    path: '/help',
  },
  {
    Page: Queries,
    path: '/queries',
  },
  {
    Page: Classifications,
    path: '/classifications',
  },
  {
    Page: AssignmentWorkspace,
    path: '/assignment-workspace',
  },
  {
    Page: SupportCases,
    path: '/support-cases',
  },
  ...(isReleaseNoteViewEnabled
    ? [
        {
          Page: ReleaseNotes,
          path: '/release-notes',
        },
      ]
    : []),
  {
    Page: SmeClassificationView,
    path: '/sme-evaluation/:classificationRequestId',
  },
  {
    Page: SmeEvaluation,
    path: '/sme-evaluation',
  },
  {
    Page: StatementReauthorization,
    path: '/statement-reauthorization',
  },
  ...([UiStage.ALPHA, UiStage.BETA].includes(stage)
    ? [
        {
          Page: ImporterManagementPage,
          path: '/importers',
        },
      ]
    : []),
];
